export default __webpack_public_path__ + "static/media/blank_s.fd5a4c01.png";